<script>
    import { onMount } from "svelte";
    import { isLoading } from "../stores.js";

    import { TabulatorFull as Tabulator } from "tabulator-tables";

    import {
        fetchGet,
        fetchPost,
        fetchPatch,
        fetchDelete,
    } from "../utils/utilsFetch.js";

    import {
        productPictureLinkFormatter,
        numberFormatter,
        oneDecimalFormatter,
        percentFormatter,
        keywordFilter,
    } from "../utils/utilsTabulator.js";

    let table, data, tableElement;

    onMount(async () => {
        $isLoading = true;

        data = await fetchGet(`/api/admin/catalogue`);

        table = new Tabulator(tableElement, {
            height: "100%",
            data: data,
            layout: "fitDataFill",
            vertAlign: "middle",
            columnCalcs: "both",
            columns: [
                {
                    title: "Шифра",
                    field: "sku",
                    headerFilter: "input",
                    headerFilterFunc: keywordFilter,
                    headerFilterPlaceholder: "⌕",
                    topCalc: "count",
                },
                {
                    title: "Дали го има?",
                    columns: [
                        {
                            title: ".csv",
                            field: "isInCSV",
                            headerFilter: "input",
                            headerFilterPlaceholder: "⌕",
                        },
                        {
                            title: "Pantheon",
                            field: "isInPantheon",
                            headerFilter: "input",
                            headerFilterPlaceholder: "⌕",
                        },
                    ],
                },

                {
                    title: "Називи",
                    columns: [
                        {
                            title: ".csv",
                            field: "nameCSV",
                            headerFilter: "input",
                            headerFilterFunc: keywordFilter,
                            headerFilterPlaceholder: "⌕",
                        },
                        {
                            title: "Pantheon",
                            field: "namePantheon",
                            headerFilter: "input",
                            headerFilterFunc: keywordFilter,
                            headerFilterPlaceholder: "⌕",
                        },
                    ],
                },
            ],
        });

        $isLoading = false;
    });
</script>

<div class="container">
    <div class="header"><b>Производи</b></div>

    <div class="content">
        <div class="table" bind:this={tableElement} />
    </div>
</div>

<style>
    .container {
        display: grid;
        grid-template-columns: 1fr;
        /* calc sprecuva tabelata da ide nadvor od content*/
        /* grid-template-rows: 30px 45px calc(100vh - 95px);  */
        grid-template-rows: auto 1fr;
        height: 100%;
    }

    .header {
        grid-row: 1/2;

        display: flex;
        flex-wrap: wrap;
        align-items: center;
        /* background: #ccc; */
        padding: 10px;
    }

    .header div {
        margin-right: 20px;
    }

    .content {
        padding: 0px 10px 10px 10px;
        grid-row: 2/-1;

        overflow: auto;
    }

    .user div {
        margin-bottom: 10px;
    }

    .form {
        display: flex;
        flex-direction: column;
    }

    .form input {
        margin-bottom: 10px;
    }
</style>
